import React, { useState } from "react";
import { Container, Row, Col, Form, Button, Alert, Breadcrumb } from "react-bootstrap";
import axios from "axios";
import { MyApi } from "../MyApi";
import { Link, useNavigate } from "react-router-dom";

export default function TestimonialForm() {
  const navigate = useNavigate(); // for back navigation

  const [form, setForm] = useState({
    uname: "",
    email: "",
    mobileno: "",
    tsubject: "",
    feedback: "",
    rating: "",
    image: null,
  });

  const [msg, setMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setForm({ ...form, [name]: files ? files[0] : value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMsg("");

    const formData = new FormData();
    Object.keys(form).forEach((key) => {
      formData.append(key, form[key]);
    });

    try {
      const res = await axios.post(
        MyApi.BASE_URL + "submit-testimonial",
        formData,
        {
          headers: {
            Authorization: MyApi.SECRET_KEY,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (res.data.status) {
        setMsg("✅ Reviews submitted successfully");
        setForm({
          uname: "",
          email: "",
          mobileno: "",
          tsubject: "",
          feedback: "",
          rating: "",
          image: null,
        });
      } else {
        setMsg("❌ " + (res.data.message || "Failed to submit Reviews"));
      }
    } catch (err) {
      console.error(err);
      if (err.response?.data?.message) {
        setMsg("❌ " + err.response.data.message);
      } else {
        setMsg("❌ Something went wrong. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
        <div className="BreadcrumbStyle">
        <Container>
        <Row className="align-items-center">
          <Col>
             <h1>Submit Your Reviews</h1>
              <Breadcrumb>
                <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/" }}>Home</Breadcrumb.Item>
                <Breadcrumb.Item active>Submit Your Reviews</Breadcrumb.Item>
              </Breadcrumb>
          </Col>
           <Col xs="12" md="auto" className="text-md-end text-start">
            <Link to="/feedback-form">
              <Button className="button_style" onClick={() => navigate(-1)}>
                &larr;  Back
              </Button> 
            </Link>
      </Col>
        </Row>
        </Container>
      </div>
    <Container className="py-5"> 

      <Row className="justify-content-center">
        <Col md={8}>
         
          {msg && <Alert variant="info">{msg}</Alert>}

          <Form onSubmit={handleSubmit} encType="multipart/form-data">
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Name <span className="text-danger">*</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="uname"
                    value={form.uname}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    value={form.email}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Mobile No <span className="text-danger">*</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="mobileno"
                    value={form.mobileno}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>City</Form.Label>
                  <Form.Control
                    type="text"
                    name="tsubject"
                    value={form.tsubject}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Form.Group className="mb-3">
              <Form.Label>Feedback <span className="text-danger">*</span></Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                name="feedback"
                value={form.feedback}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Rating <span className="text-danger">*</span></Form.Label>
                  <Form.Select
                    name="rating"
                    value={form.rating}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select Rating</option>
                    <option value="1">⭐</option>
                    <option value="2">⭐⭐</option>
                    <option value="3">⭐⭐⭐</option>
                    <option value="4">⭐⭐⭐⭐</option>
                    <option value="5">⭐⭐⭐⭐⭐</option>
                  </Form.Select>
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Photo</Form.Label>
                  <Form.Control
                    type="file"
                    name="image"
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Button
              type="submit" 
              disabled={loading}
              className="button_style"
            >
              {loading ? "Submitting..." : "Submit Reviews"}
            </Button>
          </Form>
        </Col>
      </Row>
    </Container>
    </>
  );
}
